const kobold = (level) => {
  const handle = 'kobold';
  const types = ['humanoid', 'kobold'];

  return {
    handle,
    types,
    level,
    getAbilityTrees: () => [
      {
        handle: 'kobold_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
        },
      },
    ],
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(1 + bound_level * 0.25 + Math.random() * 3),
      perception: Math.round(1 + bound_level * 0.5 + Math.random() * 3),
      mana: Math.round(1 + bound_level * 0.25 + Math.random() * 3),
      toughness: Math.round(1 + bound_level * 0.25 + Math.random() * 3),
      strength: Math.round(1 + bound_level * 0.5 + Math.random() * 3),
      willpower: Math.round(1 + bound_level * 0.25 + Math.random() * 3),
      dexterity: Math.round(1 + bound_level * 0.75 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => ['dps_close', 'tank', 'interference', 'support', 'dps_ranged'],
    getStarterEquipment: () => ({}),
    xpValue: level * 10,
    drops_gold: true,
    drops_equipment: true,
    bags: [],
    build: {
      ai: {
        priorities: ['dps_close', 'tank', 'interference', 'support', 'dps_ranged'],
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: {},
      equipped_abilities: [{ value: 'move' }, { value: 'melee_attack' }],
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = kobold;
